import { GetGeeTestCaptchaQuery, GetGeeTestCaptchaQueryVariables } from '@/typings/domain'
import apolloClient from './apolloClient'
import GetGeeTestCaptchaGQL from './graphql/GetGeeTestCaptcha.graphql'

export function getGeeTestCaptcha(variables: GetGeeTestCaptchaQueryVariables) {
  return apolloClient.query<GetGeeTestCaptchaQuery, GetGeeTestCaptchaQueryVariables>({
    query: GetGeeTestCaptchaGQL,
    variables,
    fetchPolicy: 'no-cache',
  })
}
